(function ($) {
    $(document).ready(function(){
        if (localStorage.carregando == "carregado"){
            $('.loading-bg').addClass('hide');
            $('body').removeClass('loading-overflow'); 
        }else{ 
            $('.loading-img').removeClass('hide');
            localStorage.carregando = "carregado"; 

        }
    });

    $('.slider-marcas').slick({
        dots: false,
        autoplay: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 5,
        pauseOnHover: false,
        slidesToScroll: 5, 
        arrows: true,
         responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                arrows: true
            }
        }] 
    });

    var navbar = $('.navbar-scroll');
    $(window).scroll(function () {
        if ($(window).scrollTop() <= 20) {
            navbar.removeClass('fixed');
        } else {
            navbar.addClass('fixed');
        }
    });

    $(window).bind("load", function () {
        var delay = 1800;
        var delay1 = 1000;
        setTimeout(function () {
            $('.loading-bg').addClass('hide');
            $('body').removeClass('loading-overflow'); 
        }, delay);
        setTimeout(function () {
            $('.loading-bg').addClass('opacity');
        }, delay1);


        new WOW().init();
    })

    
    
})(jQuery);

const items = [ 
  "ROTEIRO",
  "PRODUÇÃO EXECUTIVA",
  "DIREÇÃO DE CENA",
  "CAPTAÇÃO",
  "EDIÇÃO",
  "COLOR GRADING",
  "ANIMAÇÃO",
  "SONORIZAÇÃO" 
];

const horizontalTextScroll = document.querySelectorAll(".text-scroll");

function initializeItems() {
  horizontalTextScroll.forEach((scrollItem) => {
    scrollItem.innerHTML = "";
  });
}

initializeItems();

items.forEach((item) => {
  addItemToScrolls(item);
});

function addItemToScrolls(text) {
 
  horizontalTextScroll.forEach((scrollItem) => {
    const textItem = document.createElement("span");
    textItem.classList.add("text-item");
    textItem.innerHTML = text;
    scrollItem.appendChild(textItem);

    const star = createStar();
    star.classList.add("star");
    scrollItem.appendChild(star);
  });

}

function createStar() {
  const star = document.createElement("span");
  star.textContent = "•";
  return star;
}

function addItemToScrolls34(text) {
 
  horizontalTextScroll.forEach((scrollItem) => {
    const textItem = document.createElement("span");
    textItem.classList.add("text-item");
    textItem.innerHTML = text;
    scrollItem.appendChild(textItem);

    const star = createStar();
    star.classList.add("star");
    scrollItem.appendChild(star);
  });

}